import type { CountryResult } from "../../../../shared/contracts/query";
import { CountryCard } from "./CountryCard";

type Country = CountryResult["country"];

export type CountryGridProps = {
  results: readonly CountryResult[];
  expandedCountry: Country | null;
  onExpand: (country: Country) => void;
};

const COUNTRY_ORDER: readonly Country[] = ["CN", "US", "CA"];

function orderedResults(results: readonly CountryResult[]): CountryResult[] {
  const byCountry = new Map(results.map((result) => [result.country, result]));
  return COUNTRY_ORDER.flatMap((country) => {
    const result = byCountry.get(country);
    return result ? [result] : [];
  });
}

export function CountryGrid({ results, expandedCountry, onExpand }: CountryGridProps) {
  const ordered = orderedResults(results);

  return (
    <div className="country-grid-shell">
      <div className="country-grid" aria-label="三国对应结果">
        {ordered.map((result) => (
          <CountryCard
            key={result.country}
            result={result}
            expanded={expandedCountry === result.country}
            onExpand={() => onExpand(result.country)}
          />
        ))}
      </div>
    </div>
  );
}
